import { SUPRA_MAINNET_CHAIN_ID, SUPRA_TESTNET_CHAIN_ID } from './chains'

const contracts = {
  masterChef: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0x882A0f0BCe7b703DfE06D142A69f4920EB954465',
  },
  sousChef: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0x6dB5FEb245FA4b68D3ce2Db4bCb071CCeC7c3F9F',
  },
  lottery: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0x50E298C8DA58c3D7BfE040d9e3a10E62F4bc44D8',
  },
  lotteryNFT: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0xFaF04A8e6B19c5574e220b5FC55348b7ef14E769',
  },
  lotteryCore: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0x8196CAaebef9A04747a24675FDBD384b1d9B4A79',
  },
  lotteryNFTCore: {
    [SUPRA_TESTNET_CHAIN_ID]: '',
    [SUPRA_MAINNET_CHAIN_ID]: '0x6aACC299Cd128DD47ef85516523A4D1E95C70C5E',
  },
  mulltiCall: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xcA11bde05977b3631167028862bE2a173976CA11',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  multi: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x4f50b58cec1f0bbe112df189b46a84cc8943fc34',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  pancakeProfile: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  pancakeRabbits: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  bunnyFactory: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  claimRefund: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  pointCenterIfo: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  bunnySpecial: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xFee8A195570a18461146F401d6033f5ab3380849',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  xbow: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xd021178dF92542185942FaE6b4266CC6092a00e7',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  factory: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xE71205b53e2D48d8972b2e259028D83e24AE2a6B',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  nftMarketplace: {
    [SUPRA_MAINNET_CHAIN_ID]: '0xf762Da5b90Ba82675043e1a333Cf5E1203CAe893',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  hunter: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x962D45C91e2e4f29DdC96C626976ECE600908Ba6',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  tracker: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x8045ed9dDA73eDEAD7755BF294B183018B2a42E9',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  hunterCoreLP: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x798489bacDDf8A3c5B1C23E7c24833B349F41dED',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  kyudoNft: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x54DF7dDF83CfB078E074D4331E9f956A2ec12b61',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  kyudoStaking: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x03257bDe6330E7c1BE9f0BC69445f7F4b31dbD13',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  acoreCoreLP: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x1B55BE6b76Eba3c1af8CFfd933bC61BCB2dc4a66',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
  acore: {
    [SUPRA_MAINNET_CHAIN_ID]: '0x1c92E17CD1893e8535F48b03fE1207A1B12EaEAB',
    [SUPRA_TESTNET_CHAIN_ID]: '',
  },
}

export default contracts
